import React from "react";
import ReactDOM from 'react-dom/client';
import $ from "jquery";

import * as MutaSpinnerSvgUtils from "./MutaSpinnerSvgUtils";

import MutaSpinner from "../component/MutaSpinner";

export function showMutaSpinner(icon, dismissTimeout, type) {
    let root = $("#root");

    let divForSpinner = $('<div></div>');
    root.append(divForSpinner);

    let spinnerComponent;
    let spinnerType = type ? type : MutaSpinnerSvgUtils.MUTANOIDS
    ReactDOM.createRoot(divForSpinner[0]).render(<MutaSpinner ref={c => spinnerComponent = c} icon={icon} isLoading={true} spinnerType={spinnerType}/>);

    if (dismissTimeout) {
        setTimeout(() => { divForSpinner.remove() }, dismissTimeout);
    }
    return divForSpinner;
}